module.exports = __webpack_public_path__ + "static/media/image4.ac90fe09.png";